module.exports = __webpack_public_path__ + "img/img35.688e9b8c.svg";